
import universal, { setHasBabelPlugin } from '/u/for_penguins/our-assets/equilibrium/node_modules/react-universal-component/dist/index.js'


setHasBabelPlugin()

const universalOptions = {
  loading: () => null,
  error: props => {
    console.error(props.error);
    return <div>An error occurred loading this page's template. More information is available in the console.</div>;
  },
}

const t_0 = universal(import('../node_modules/react-static/lib/browser/components/Default404'), universalOptions)
const t_1 = universal(import('../src/pages/index.js'), universalOptions)
const t_2 = universal(import('../src/HomePage'), universalOptions)
const t_3 = universal(import('../src/AppliancesPage'), universalOptions)
const t_4 = universal(import('../src/PricingPage'), universalOptions)


// Template Map
export default {
  '../node_modules/react-static/lib/browser/components/Default404': t_0,
'../src/pages/index.js': t_1,
'../src/HomePage': t_2,
'../src/AppliancesPage': t_3,
'../src/PricingPage': t_4
}

export const notFoundTemplate = "../node_modules/react-static/lib/browser/components/Default404"
